module.exports = __webpack_public_path__ + "static/media/Statua_047.d0cdca59.jpg";